import styled from 'styled-components';

export const Container = styled.div<{ padding?: string }>`
  padding: ${({ padding }) => (padding ? padding : '1rem')};
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
`;

export const InputsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  width: 100%;
`;
